import Api from 'lib/api';

import { toast } from 'react-toastify';

const api = Api.getInstance();

const ns = 'app/login/';

export const LOGIN_START = ns + 'LOGIN_START';
export const LOGIN_SUCCESS = ns + 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = ns + 'LOGIN_FAILURE';
export const LOGOUT = ns + 'LOGOUT';

export const CHECK_START = ns + 'CHECK_START';
export const CHECK_SUCCESS = ns + 'CHECK_SUCCESS';
export const CHECK_FAILURE = ns + 'CHECK_FAILURE';

export const VERIFY_START = ns + 'VERIFY_START';
export const VERIFY_SUCCESS = ns + 'VERIFY_SUCCESS';
export const VERIFY_FAILURE = ns + 'VERIFY_FAILURE';

export const COMPLETE_SETUP = ns + 'COMPLETE_SETUP';

export const TOUR_LOADED = ns + 'TOUR_LOADED';
export const TOUR_STEPS_VIEWED = ns + 'TOUR_STEP_VIEWED';

async function loadTour(dispatch) {
  const response = await api.get('tours');
  const { data } = response;
  if (data.steps) {
    dispatch({
      type: TOUR_LOADED,
      payload: data.steps
    });
  }
}

export function viewSteps(steps) {
  const _s = steps.slice();
  return async dispatch => {
    const saveData = {
      id: _s.map(s => s.id)
    };
    dispatch({
      type: TOUR_STEPS_VIEWED,
      payload: saveData.id
    });
    const response = await api.post('tours/view', saveData);
    if (!response.data.success) {
      console.error('Error marking step as viewed!', response);
    }
  };
}

export function login(credentials, history) {
  return async dispatch => {
    dispatch({
      type: LOGIN_START
    });

    try {
      const response = await api.post('users/token', credentials);

      localStorage.setItem('user', JSON.stringify(response.data.user));
      localStorage.setItem('token', response.data.data.token);

      toast('Welcome!');

      dispatch({
        type: LOGIN_SUCCESS,
        payload: response.data.user
      });

      loadTour(dispatch);

      if (response.data.user.setup_complete) {
        history.push('/dashboard');
      } else {
        history.push('/account-setup');
      }
    } catch (error) {
      localStorage.removeItem('user');
      localStorage.removeItem('token');

      dispatch({
        type: LOGIN_FAILURE,
        payload:
          error.response && error.response.data ? error.response.data : error
      });
    }
  };
}

export function checkToken() {
  return async dispatch => {
    dispatch({
      type: CHECK_START
    });

    try {
      const response = await api.get('users/check-token');

      if (response.data.success) {
        loadTour(dispatch);
        dispatch({
          type: CHECK_SUCCESS,
          payload: response.data.user
        });
      } else {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
      }
    } catch (error) {
      localStorage.removeItem('user');
      localStorage.removeItem('token');

      dispatch({
        type: CHECK_FAILURE,
        payload: error
      });
    }
  };
}

export function logout(history) {
  return dispatch => {
    history.push('/');

    dispatch({
      type: LOGOUT
    });

    localStorage.removeItem('user');
    localStorage.removeItem('token');

    toast('You have been logged out!');
  };
}

export function verify(token) {
  return dispatch => {
    dispatch({
      type: VERIFY_START
    });

    api.get(`users/verify/${token}`).then(
      response => {
        dispatch({
          type: VERIFY_SUCCESS,
          payload: response.data
        });
      },
      error => {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        dispatch({
          type: VERIFY_FAILURE
        });
      }
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/app/login/actions.js